import { ClipboardCheck, ShieldCheck } from "lucide-react";
import { WORKLOAD_NAME } from "./internals";

export function ReviewVisual() {
  return (
    <div className="min-h-[220px] rounded-lg border border-border bg-surface p-4 shadow-sm sm:min-h-[260px] sm:p-5">
      <div className="flex items-center justify-between gap-3 border-b border-border pb-4">
        <div>
          <p className="font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary">
            Privacy review
          </p>
          <h3 className="mt-1 text-lg font-semibold tracking-[-0.015em] text-foreground">
            {WORKLOAD_NAME} review
          </h3>
        </div>
        <span className="rounded-sm border border-primary/30 bg-primary-tint px-2 py-1 text-[12px] font-semibold text-primary">
          Pre-filled
        </span>
      </div>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        <div className="rounded-md border border-primary/25 bg-primary-tint/45 p-4">
          <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
            <ShieldCheck className="size-4 text-primary" />
            Derived context
          </p>
          <div className="mt-4 grid gap-2 text-sm text-foreground-muted">
            {["Data stores", "Data flows", "Resources", "Regions"].map((item) => (
              <span key={item} className="rounded-sm border border-primary/15 bg-surface px-2 py-1">
                {item}
              </span>
            ))}
          </div>
        </div>
        <div className="rounded-md border border-border bg-background p-4">
          <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
            <ClipboardCheck className="size-4 text-foreground-muted" />
            Builder input required
          </p>
          <div className="mt-4 grid gap-2 text-sm text-foreground-muted">
            {["Purpose", "Lawful basis", "Retention justification"].map((item) => (
              <span key={item} className="rounded-sm border border-border bg-surface px-2 py-1">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
